// import React from "react";
// import constants from "../constants";

// export default function TestSvgIcon(Props) {
//   return Props.libType === constants.libTypeIds.CONTENT &&
//     Props.videoContent === 1 ? (
//     <>
//       <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <g clip-path="url(#clip0_459_11013)">
//           <path
//             d="M10 20C4.48633 20 0 15.5137 0 10C0 4.48633 4.48633 0 10 0C15.5137 0 20 4.48633 20 10C20 15.5137 15.5137 20 10 20ZM10 1.66602C5.4043 1.66602 1.66602 5.4043 1.66602 10C1.66602 14.5957 5.4043 18.334 10 18.334C14.5957 18.334 18.334 14.5957 18.334 10C18.334 5.4043 14.5957 1.66602 10 1.66602Z"
//             fill={
//               Props.active ? "#F96343" : Props.disabled ? "#757E91" : "#EAECF0"
//             }
//           />
//           <path
//             d="M8.49219 13.4414C8.34766 13.4414 8.20508 13.4043 8.07617 13.3301C7.81836 13.1816 7.66016 12.9063 7.66016 12.6074V7.5C7.66016 7.20312 7.81836 6.92773 8.07617 6.77734C8.33398 6.62891 8.65234 6.62891 8.91016 6.77734L13.334 9.33203C13.5918 9.48047 13.75 9.75586 13.75 10.0547C13.75 10.3516 13.5918 10.627 13.334 10.7773L8.9082 13.3301C8.7793 13.4063 8.63672 13.4414 8.49219 13.4414Z"
//             fill={
//               Props.active ? "#F96343" : Props.disabled ? "#757E91" : "#EAECF0"
//             }
//           />
//         </g>
//         <defs>
//           <clipPath id="clip0_459_11013">
//             <rect width="20" height="20" fill="white" />
//           </clipPath>
//         </defs>
//       </svg>
//     </>
//   ) : Props.libType === constants.libTypeIds.CONTENT ? (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.component === "resume"
//             ? Props.stroke
//               ? Props.stroke
//               : "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//         d="M11.6666 1.66667H4.99992C4.55789 1.66667 4.13397 1.84226 3.82141 2.15482C3.50885 2.46738 3.33325 2.89131 3.33325 3.33333V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8452C16.491 17.5326 16.6666 17.1087 16.6666 16.6667V6.66667M11.6666 1.66667L16.6666 6.66667M11.6666 1.66667V6.66667H16.6666M13.3333 10.8333H6.66659M13.3333 14.1667H6.66659M8.33325 7.5H6.66659"
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.MCQ ? (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M6.66667 5H17.5M6.66667 10H17.5M6.66667 15H17.5M2.5 5H2.50833M2.5 10H2.50833M2.5 15H2.50833"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.DESCRIPTIVE &&
//     Props.videoQn === 1 ? (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.6"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M18.3346 7.44289C18.3346 6.93804 18.3346 6.68562 18.2348 6.56873C18.1482 6.46731 18.0182 6.41349 17.8853 6.42395C17.732 6.43602 17.5535 6.61451 17.1966 6.97149L14.168 10.0001L17.1966 13.0287C17.5535 13.3857 17.732 13.5641 17.8853 13.5762C18.0182 13.5867 18.1482 13.5328 18.2348 13.4314C18.3346 13.3145 18.3346 13.0621 18.3346 12.5573V7.44289Z"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//       <path
//         strokeWidth="1.6"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M1.66797 8.16675C1.66797 6.76662 1.66797 6.06655 1.94045 5.53177C2.18014 5.06137 2.56259 4.67892 3.03299 4.43923C3.56777 4.16675 4.26784 4.16675 5.66797 4.16675H10.168C11.5681 4.16675 12.2682 4.16675 12.8029 4.43923C13.2734 4.67892 13.6558 5.06137 13.8955 5.53177C14.168 6.06655 14.168 6.76662 14.168 8.16675V11.8334C14.168 13.2335 14.168 13.9336 13.8955 14.4684C13.6558 14.9388 13.2734 15.3212 12.8029 15.5609C12.2682 15.8334 11.5681 15.8334 10.168 15.8334H5.66797C4.26784 15.8334 3.56777 15.8334 3.03299 15.5609C2.56259 15.3212 2.18014 14.9388 1.94045 14.4684C1.66797 13.9336 1.66797 13.2335 1.66797 11.8334V8.16675Z"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.DESCRIPTIVE &&
//     Props.autoEval === 0 ? (
//     <svg
//       width="17"
//       height="20"
//       fill="none"
//       viewBox="0 0 17 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//         d="M14.6668 7.91667V5.66667C14.6668 4.26654 14.6668 3.56647 14.3943 3.0317C14.1547 2.56129 13.7722 2.17884 13.3018 1.93916C12.767 1.66667 12.067 1.66667 10.6668 1.66667H5.3335C3.93336 1.66667 3.2333 1.66667 2.69852 1.93916C2.22811 2.17884 1.84566 2.56129 1.60598 3.0317C1.3335 3.56647 1.3335 4.26654 1.3335 5.66667V14.3333C1.3335 15.7335 1.3335 16.4335 1.60598 16.9683C1.84566 17.4387 2.22811 17.8212 2.69852 18.0609C3.2333 18.3333 3.93336 18.3333 5.3335 18.3333H9.66683M9.66683 9.16667H4.66683M6.3335 12.5H4.66683M11.3335 5.83334H4.66683M11.7502 12.5019C11.897 12.0845 12.1868 11.7325 12.5683 11.5083C12.9497 11.2841 13.3982 11.2022 13.8343 11.277C14.2704 11.3518 14.666 11.5785 14.9509 11.917C15.2359 12.2555 15.3919 12.6839 15.3912 13.1264C15.3912 14.3755 13.5176 15 13.5176 15M13.5417 17.5H13.5501"
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.DESCRIPTIVE &&
//     Props.autoEval === 1 ? (
//     <svg
//       width="18"
//       height="20"
//       fill="none"
//       viewBox="0 0 18 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M3.16671 15.4165C3.16671 15.8035 3.16671 15.997 3.1881 16.1595C3.33579 17.2813 4.21856 18.1641 5.34039 18.3118C5.50285 18.3332 5.69636 18.3332 6.08337 18.3332H12.5C13.9002 18.3332 14.6002 18.3332 15.135 18.0607C15.6054 17.821 15.9879 17.4386 16.2276 16.9681C16.5 16.4334 16.5 15.7333 16.5 14.3332V8.32336C16.5 7.71188 16.5 7.40614 16.431 7.11842C16.3697 6.86333 16.2687 6.61947 16.1316 6.39579C15.977 6.1435 15.7608 5.9273 15.3285 5.49493L12.6716 2.83808C12.2392 2.4057 12.023 2.18951 11.7708 2.0349C11.5471 1.89783 11.3032 1.79682 11.0481 1.73558C10.7604 1.6665 10.4547 1.6665 9.84319 1.6665H6.08337C5.69636 1.6665 5.50285 1.6665 5.34039 1.68789C4.21856 1.83558 3.33579 2.71835 3.1881 3.84019C3.16671 4.00265 3.16671 4.19615 3.16671 4.58317M6.50004 12.0832L8.58337 9.99984L6.50004 7.9165M3.16671 7.9165L1.08337 9.99984L3.16671 12.0832"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.CODING_CHALLENGE ? (
//     <svg
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       width={Props.component === "testDetail" ? "14" : "20"}
//       height={Props.component === "testDetail" ? "12" : "18"}
//       viewBox={Props.component === "testDetail" ? "0 0 14 12" : "0 0 20 18"}
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={Props.component === "testDetail" ? "1.2" : "1.5"}
//         d={
//           Props.component === "testDetail"
//             ? "M9.9165 8.91667L12.8332 6L9.9165 3.08333M4.08317 3.08333L1.1665 6L4.08317 8.91667M8.1665 0.75L5.83317 11.25"
//             : "M14.1665 13.1667L18.3332 9L14.1665 4.83333M5.83317 4.83333L1.6665 9L5.83317 13.1667M11.6665 1.5L8.33317 16.5"
//         }
//         stroke={
//           Props.component === "testDetail"
//             ? "#E54B2A"
//             : Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.SQL ? (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 24 24"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M20 11.75C20 16.417 4 16.417 4 11.75M12 3C7.582 3 4 4.29 4 5.88C4 10.04 20 10.04 20 5.88C20 4.29 16.418 3 12 3Z"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M4 6V18.165C4 21.945 20 21.945 20 18.165V6"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.ASSIGNMENT ? (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//         d="M16.6666 10.4167V5.66666C16.6666 4.26653 16.6666 3.56647 16.3941 3.03169C16.1544 2.56128 15.772 2.17883 15.3016 1.93915C14.7668 1.66666 14.0667 1.66666 12.6666 1.66666H7.33325C5.93312 1.66666 5.23306 1.66666 4.69828 1.93915C4.22787 2.17883 3.84542 2.56128 3.60574 3.03169C3.33325 3.56647 3.33325 4.26653 3.33325 5.66666V14.3333C3.33325 15.7335 3.33325 16.4335 3.60574 16.9683C3.84542 17.4387 4.22787 17.8212 4.69828 18.0608C5.23306 18.3333 5.93312 18.3333 7.33325 18.3333H9.99992M11.6666 9.16666H6.66659M8.33325 12.5H6.66659M13.3333 5.83333H6.66659M12.0833 15.8333L13.7499 17.5L17.4999 13.75"
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.TEST ? (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 28 28"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="2"
//         stroke="#F96343"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M24.5 20.9999L23.3332 22.2763C22.7144 22.9531 21.8752 23.3333 21.0001 23.3333C20.1251 23.3333 19.2859 22.9531 18.6671 22.2763C18.0474 21.6009 17.2083 21.2217 16.3335 21.2217C15.4588 21.2217 14.6197 21.6009 14 22.2763M3.5 23.3333H5.45363C6.02435 23.3333 6.3097 23.3333 6.57824 23.2688C6.81632 23.2116 7.04393 23.1174 7.2527 22.9894C7.48817 22.8451 7.68995 22.6434 8.0935 22.2398L22.75 7.58327C23.7165 6.61677 23.7165 5.04977 22.75 4.08327C21.7835 3.11677 20.2165 3.11677 19.25 4.08327L4.59347 18.7398C4.18992 19.1434 3.98814 19.3451 3.84384 19.5806C3.71591 19.7894 3.62163 20.017 3.56447 20.2551C3.5 20.5236 3.5 20.809 3.5 21.3797V23.3333Z"
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.LEARNINGPATH ? (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         stroke="#F96343"
//         strokeWidth="1.6"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M9.16797 3.75008H15.2513C16.1847 3.75008 16.6514 3.75008 17.008 3.93174C17.3216 4.09153 17.5765 4.34649 17.7363 4.6601C17.918 5.01662 17.918 5.48333 17.918 6.41675V7.50008C17.918 8.27665 17.918 8.66494 17.7911 8.97122C17.6219 9.3796 17.2975 9.70406 16.8891 9.87321C16.5828 10.0001 16.1945 10.0001 15.418 10.0001M10.8346 16.2501H4.7513C3.81788 16.2501 3.35117 16.2501 2.99465 16.0684C2.68105 15.9086 2.42608 15.6537 2.26629 15.3401C2.08464 14.9835 2.08464 14.5168 2.08464 13.5834V12.5001C2.08464 11.7235 2.08464 11.3352 2.2115 11.0289C2.38066 10.6206 2.70512 10.2961 3.1135 10.1269C3.41978 10.0001 3.80807 10.0001 4.58464 10.0001M8.58464 12.0834H11.418C11.6513 12.0834 11.768 12.0834 11.8571 12.038C11.9355 11.9981 11.9993 11.9343 12.0392 11.8559C12.0846 11.7668 12.0846 11.6501 12.0846 11.4167V8.58342C12.0846 8.35006 12.0846 8.23338 12.0392 8.14425C11.9993 8.06585 11.9355 8.00211 11.8571 7.96216C11.768 7.91675 11.6513 7.91675 11.418 7.91675H8.58464C8.35128 7.91675 8.2346 7.91675 8.14547 7.96216C8.06707 8.00211 8.00333 8.06585 7.96338 8.14425C7.91797 8.23338 7.91797 8.35006 7.91797 8.58342V11.4167C7.91797 11.6501 7.91797 11.7668 7.96338 11.8559C8.00333 11.9343 8.06707 11.9981 8.14547 12.038C8.2346 12.0834 8.35128 12.0834 8.58464 12.0834ZM14.8346 18.3334H17.668C17.9013 18.3334 18.018 18.3334 18.1071 18.288C18.1855 18.2481 18.2493 18.1843 18.2892 18.1059C18.3346 18.0168 18.3346 17.9001 18.3346 17.6667V14.8334C18.3346 14.6001 18.3346 14.4834 18.2892 14.3943C18.2493 14.3159 18.1855 14.2521 18.1071 14.2122C18.018 14.1667 17.9013 14.1667 17.668 14.1667H14.8346C14.6013 14.1667 14.4846 14.1667 14.3955 14.2122C14.3171 14.2521 14.2533 14.3159 14.2134 14.3943C14.168 14.4834 14.168 14.6001 14.168 14.8334V17.6667C14.168 17.9001 14.168 18.0168 14.2134 18.1059C14.2533 18.1843 14.3171 18.2481 14.3955 18.288C14.4846 18.3334 14.6013 18.3334 14.8346 18.3334ZM2.33464 5.83341H5.16797C5.40132 5.83341 5.518 5.83341 5.60713 5.788C5.68553 5.74805 5.74927 5.68431 5.78922 5.60591C5.83464 5.51678 5.83464 5.4001 5.83464 5.16675V2.33341C5.83464 2.10006 5.83464 1.98338 5.78922 1.89425C5.74927 1.81585 5.68553 1.75211 5.60713 1.71216C5.518 1.66675 5.40132 1.66675 5.16797 1.66675H2.33464C2.10128 1.66675 1.9846 1.66675 1.89547 1.71216C1.81707 1.75211 1.75333 1.81585 1.71338 1.89425C1.66797 1.98338 1.66797 2.10006 1.66797 2.33341V5.16675C1.66797 5.4001 1.66797 5.51678 1.71338 5.60591C1.75333 5.68431 1.81707 5.74805 1.89547 5.788C1.9846 5.83341 2.10128 5.83341 2.33464 5.83341Z"
//       />
//     </svg>
//   ) : Props.libType === constants.libTypeIds.SQL ? (
//     <svg
//       width="24"
//       height="24"
//       fill="none"
//       viewBox="0 0 24 24"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M20 11.75C20 16.417 4 16.417 4 11.75M12 3C7.582 3 4 4.29 4 5.88C4 10.04 20 10.04 20 5.88C20 4.29 16.418 3 12 3Z"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M4 6V18.165C4 21.945 20 21.945 20 18.165V6"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//       />
//     </svg>
//   ) : (
//     <svg
//       width="20"
//       height="20"
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         stroke={
//           Props.component === "learnerDashBoard"
//             ? "#344054"
//             : Props.disabled
//             ? "#667085"
//             : Props.active
//             ? "#F96343"
//             : "#EAECF0"
//         }
//         d="M4.16683 15.4167C4.16683 15.8037 4.16683 15.9972 4.18822 16.1597C4.33591 17.2815 5.21868 18.1643 6.34051 18.312C6.50297 18.3333 6.69648 18.3333 7.0835 18.3333H13.5002C14.9003 18.3333 15.6004 18.3333 16.1351 18.0609C16.6055 17.8212 16.988 17.4387 17.2277 16.9683C17.5002 16.4335 17.5002 15.7335 17.5002 14.3333V8.32353C17.5002 7.71205 17.5002 7.40631 17.4311 7.11859C17.3698 6.8635 17.2688 6.61964 17.1318 6.39596C16.9772 6.14367 16.761 5.92747 16.3286 5.4951L13.6717 2.83824C13.2394 2.40587 13.0232 2.18968 12.7709 2.03507C12.5472 1.898 12.3033 1.79699 12.0482 1.73575C11.7605 1.66667 11.4548 1.66667 10.8433 1.66667H7.0835C6.69648 1.66667 6.50297 1.66667 6.34051 1.68806C5.21868 1.83575 4.33591 2.71852 4.18822 3.84036C4.16683 4.00281 4.16683 4.19632 4.16683 4.58334M7.50016 12.0833L9.5835 10L7.50016 7.91667M4.16683 7.91667L2.0835 10L4.16683 12.0833"
//       />
//     </svg>
//   );
// }

import React from "react";
import constants from "../constants";

export default function TestSvgIcon(Props) {
  return Props.libType === constants.libTypeIds.CONTENT &&
    Props.videoContent === 1 ? (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={Props.className ?? ""}
      >
        <g clip-path="url(#clip0_459_11013)">
          <path
            d="M10 20C4.48633 20 0 15.5137 0 10C0 4.48633 4.48633 0 10 0C15.5137 0 20 4.48633 20 10C20 15.5137 15.5137 20 10 20ZM10 1.66602C5.4043 1.66602 1.66602 5.4043 1.66602 10C1.66602 14.5957 5.4043 18.334 10 18.334C14.5957 18.334 18.334 14.5957 18.334 10C18.334 5.4043 14.5957 1.66602 10 1.66602Z"
            fill={
              Props.active ? "#F96343" : Props.disabled ? "#757E91" : "#EAECF0"
            }
          />
          <path
            d="M8.49219 13.4414C8.34766 13.4414 8.20508 13.4043 8.07617 13.3301C7.81836 13.1816 7.66016 12.9063 7.66016 12.6074V7.5C7.66016 7.20312 7.81836 6.92773 8.07617 6.77734C8.33398 6.62891 8.65234 6.62891 8.91016 6.77734L13.334 9.33203C13.5918 9.48047 13.75 9.75586 13.75 10.0547C13.75 10.3516 13.5918 10.627 13.334 10.7773L8.9082 13.3301C8.7793 13.4063 8.63672 13.4414 8.49219 13.4414Z"
            fill={
              Props.active ? "#F96343" : Props.disabled ? "#757E91" : "#EAECF0"
            }
          />
        </g>
        <defs>
          <clipPath id="clip0_459_11013">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ) : Props.libType === constants.libTypeIds.CONTENT ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "20"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.component === "resume"
            ? Props.stroke
              ? Props.stroke
              : "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
        d="M11.6666 1.66667H4.99992C4.55789 1.66667 4.13397 1.84226 3.82141 2.15482C3.50885 2.46738 3.33325 2.89131 3.33325 3.33333V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8452C16.491 17.5326 16.6666 17.1087 16.6666 16.6667V6.66667M11.6666 1.66667L16.6666 6.66667M11.6666 1.66667V6.66667H16.6666M13.3333 10.8333H6.66659M13.3333 14.1667H6.66659M8.33325 7.5H6.66659"
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.MCQ ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "20"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.66667 5H17.5M6.66667 10H17.5M6.66667 15H17.5M2.5 5H2.50833M2.5 10H2.50833M2.5 15H2.50833"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.DESCRIPTIVE && Props.videoQn ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "20"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      className={Props.className ?? ""}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.3346 7.44289C18.3346 6.93804 18.3346 6.68562 18.2348 6.56873C18.1482 6.46731 18.0182 6.41349 17.8853 6.42395C17.732 6.43602 17.5535 6.61451 17.1966 6.97149L14.168 10.0001L17.1966 13.0287C17.5535 13.3857 17.732 13.5641 17.8853 13.5762C18.0182 13.5867 18.1482 13.5328 18.2348 13.4314C18.3346 13.3145 18.3346 13.0621 18.3346 12.5573V7.44289Z"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
      <path
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.66797 8.16675C1.66797 6.76662 1.66797 6.06655 1.94045 5.53177C2.18014 5.06137 2.56259 4.67892 3.03299 4.43923C3.56777 4.16675 4.26784 4.16675 5.66797 4.16675H10.168C11.5681 4.16675 12.2682 4.16675 12.8029 4.43923C13.2734 4.67892 13.6558 5.06137 13.8955 5.53177C14.168 6.06655 14.168 6.76662 14.168 8.16675V11.8334C14.168 13.2335 14.168 13.9336 13.8955 14.4684C13.6558 14.9388 13.2734 15.3212 12.8029 15.5609C12.2682 15.8334 11.5681 15.8334 10.168 15.8334H5.66797C4.26784 15.8334 3.56777 15.8334 3.03299 15.5609C2.56259 15.3212 2.18014 14.9388 1.94045 14.4684C1.66797 13.9336 1.66797 13.2335 1.66797 11.8334V8.16675Z"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.DESCRIPTIVE &&
    Props.aiInterview ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "17"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0398 0.122132C12.0057 0.208953 11.9297 0.4171 11.8711 0.584617C11.7206 1.01384 11.5298 1.31948 11.2236 1.6213C10.8941 1.94622 10.6209 2.10717 10.065 2.30396C9.82545 2.38876 9.62944 2.48817 9.62944 2.52486C9.62944 2.56156 9.77487 2.63725 9.95256 2.693C10.9768 3.01438 11.4722 3.47642 11.8809 4.49152C11.9922 4.768 12.1081 5.00245 12.1387 5.01262C12.1691 5.02279 12.265 4.82723 12.3518 4.57806C12.674 3.65231 13.175 3.12879 14.0683 2.78432C14.3139 2.68963 14.5409 2.61214 14.5728 2.61214C14.6047 2.61214 14.6308 2.57746 14.6308 2.53515C14.6308 2.48985 14.4519 2.3946 14.1968 2.30402C13.1978 1.94937 12.6494 1.37579 12.3028 0.322861C12.1846 -0.0360574 12.121 -0.0846098 12.0398 0.122132ZM6.20165 3.13194C6.17215 3.20145 6.02093 3.60392 5.86566 4.02623C5.4265 5.22071 4.97435 5.91888 4.25157 6.51854C3.72171 6.95815 3.22376 7.22176 2.22574 7.59102C1.18663 7.97545 1.15207 8.03063 1.80427 8.26306C3.14694 8.74167 3.66079 9.0018 4.26264 9.50778C5.02026 10.1447 5.46426 10.8529 5.94636 12.1934C6.09089 12.5952 6.2329 12.9482 6.26189 12.9777C6.35675 13.0743 6.46476 12.8853 6.70999 12.1934C7.16259 10.9165 7.52825 10.3196 8.29677 9.6032C8.83844 9.09834 9.37162 8.80011 10.3809 8.43743C10.8327 8.27508 11.233 8.11161 11.2705 8.07413C11.3819 7.96269 11.233 7.87351 10.5005 7.61338C9.27558 7.17832 8.89002 6.96506 8.25552 6.37153C7.52313 5.6864 7.15332 5.07674 6.70814 3.82033C6.40688 2.96993 6.32034 2.85237 6.20165 3.13194ZM12.0464 11.1116C12.0172 11.1812 11.9296 11.3998 11.8516 11.5974C11.4871 12.5218 10.9524 13.007 9.95256 13.3207C9.77487 13.3765 9.62944 13.4522 9.62944 13.4889C9.62944 13.5256 9.82545 13.625 10.065 13.7098C11.0666 14.0644 11.5311 14.5194 11.8955 15.5031C11.9936 15.7681 12.0983 15.9916 12.128 15.9998C12.1578 16.008 12.2621 15.7979 12.3599 15.5328C12.5712 14.9603 12.7359 14.6905 13.0656 14.3774C13.3979 14.0618 13.6898 13.8896 14.2001 13.7085C14.453 13.6187 14.6308 13.5238 14.6308 13.4786C14.6308 13.4363 14.6047 13.4016 14.5728 13.4016C14.5409 13.4016 14.3139 13.3241 14.0683 13.2294C13.1755 12.8851 12.674 12.3614 12.3522 11.437C12.2657 11.1885 12.1735 10.9852 12.1473 10.9852C12.1211 10.9852 12.0757 11.0421 12.0464 11.1116Z"
        fill={ Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"}
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.DESCRIPTIVE ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "17"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      fill="none"
      viewBox="0 0 17 20"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
        d="M14.6668 7.91667V5.66667C14.6668 4.26654 14.6668 3.56647 14.3943 3.0317C14.1547 2.56129 13.7722 2.17884 13.3018 1.93916C12.767 1.66667 12.067 1.66667 10.6668 1.66667H5.3335C3.93336 1.66667 3.2333 1.66667 2.69852 1.93916C2.22811 2.17884 1.84566 2.56129 1.60598 3.0317C1.3335 3.56647 1.3335 4.26654 1.3335 5.66667V14.3333C1.3335 15.7335 1.3335 16.4335 1.60598 16.9683C1.84566 17.4387 2.22811 17.8212 2.69852 18.0609C3.2333 18.3333 3.93336 18.3333 5.3335 18.3333H9.66683M9.66683 9.16667H4.66683M6.3335 12.5H4.66683M11.3335 5.83334H4.66683M11.7502 12.5019C11.897 12.0845 12.1868 11.7325 12.5683 11.5083C12.9497 11.2841 13.3982 11.2022 13.8343 11.277C14.2704 11.3518 14.666 11.5785 14.9509 11.917C15.2359 12.2555 15.3919 12.6839 15.3912 13.1264C15.3912 14.3755 13.5176 15 13.5176 15M13.5417 17.5H13.5501"
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.CODING_SNIPPET ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "18"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      fill="none"
      viewBox="0 0 18 20"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.16671 15.4165C3.16671 15.8035 3.16671 15.997 3.1881 16.1595C3.33579 17.2813 4.21856 18.1641 5.34039 18.3118C5.50285 18.3332 5.69636 18.3332 6.08337 18.3332H12.5C13.9002 18.3332 14.6002 18.3332 15.135 18.0607C15.6054 17.821 15.9879 17.4386 16.2276 16.9681C16.5 16.4334 16.5 15.7333 16.5 14.3332V8.32336C16.5 7.71188 16.5 7.40614 16.431 7.11842C16.3697 6.86333 16.2687 6.61947 16.1316 6.39579C15.977 6.1435 15.7608 5.9273 15.3285 5.49493L12.6716 2.83808C12.2392 2.4057 12.023 2.18951 11.7708 2.0349C11.5471 1.89783 11.3032 1.79682 11.0481 1.73558C10.7604 1.6665 10.4547 1.6665 9.84319 1.6665H6.08337C5.69636 1.6665 5.50285 1.6665 5.34039 1.68789C4.21856 1.83558 3.33579 2.71835 3.1881 3.84019C3.16671 4.00265 3.16671 4.19615 3.16671 4.58317M6.50004 12.0832L8.58337 9.99984L6.50004 7.9165M3.16671 7.9165L1.08337 9.99984L3.16671 12.0832"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.CODING_CHALLENGE ? (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={
        Props.component === "testDetail" || Props.component === "DashBoard"
          ? "12"
          : "20"
      }
      height={
        Props.component === "testDetail" || Props.component === "DashBoard"
          ? "12"
          : "18"
      }
      viewBox="0 0 20 18"
      className={Props.className ?? ""}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={Props.component === "testDetail" ? "1.2" : "1.5"}
        d={
          Props.component === "testDetail"
            ? "M9.9165 8.91667L12.8332 6L9.9165 3.08333M4.08317 3.08333L1.1665 6L4.08317 8.91667M8.1665 0.75L5.83317 11.25"
            : "M14.1665 13.1667L18.3332 9L14.1665 4.83333M5.83317 4.83333L1.6665 9L5.83317 13.1667M11.6665 1.5L8.33317 16.5"
        }
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.component === "testDetail"
            ? "#E54B2A"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.SQL ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "20"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 11.75C20 16.417 4 16.417 4 11.75M12 3C7.582 3 4 4.29 4 5.88C4 10.04 20 10.04 20 5.88C20 4.29 16.418 3 12 3Z"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 6V18.165C4 21.945 20 21.945 20 18.165V6"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.ASSIGNMENT ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "20"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
        d="M16.6666 10.4167V5.66666C16.6666 4.26653 16.6666 3.56647 16.3941 3.03169C16.1544 2.56128 15.772 2.17883 15.3016 1.93915C14.7668 1.66666 14.0667 1.66666 12.6666 1.66666H7.33325C5.93312 1.66666 5.23306 1.66666 4.69828 1.93915C4.22787 2.17883 3.84542 2.56128 3.60574 3.03169C3.33325 3.56647 3.33325 4.26653 3.33325 5.66666V14.3333C3.33325 15.7335 3.33325 16.4335 3.60574 16.9683C3.84542 17.4387 4.22787 17.8212 4.69828 18.0608C5.23306 18.3333 5.93312 18.3333 7.33325 18.3333H9.99992M11.6666 9.16666H6.66659M8.33325 12.5H6.66659M13.3333 5.83333H6.66659M12.0833 15.8333L13.7499 17.5L17.4999 13.75"
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.TEST ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="2"
        stroke="#F96343"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M24.5 20.9999L23.3332 22.2763C22.7144 22.9531 21.8752 23.3333 21.0001 23.3333C20.1251 23.3333 19.2859 22.9531 18.6671 22.2763C18.0474 21.6009 17.2083 21.2217 16.3335 21.2217C15.4588 21.2217 14.6197 21.6009 14 22.2763M3.5 23.3333H5.45363C6.02435 23.3333 6.3097 23.3333 6.57824 23.2688C6.81632 23.2116 7.04393 23.1174 7.2527 22.9894C7.48817 22.8451 7.68995 22.6434 8.0935 22.2398L22.75 7.58327C23.7165 6.61677 23.7165 5.04977 22.75 4.08327C21.7835 3.11677 20.2165 3.11677 19.25 4.08327L4.59347 18.7398C4.18992 19.1434 3.98814 19.3451 3.84384 19.5806C3.71591 19.7894 3.62163 20.017 3.56447 20.2551C3.5 20.5236 3.5 20.809 3.5 21.3797V23.3333Z"
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.LEARNINGPATH ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        stroke="#F96343"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.16797 3.75008H15.2513C16.1847 3.75008 16.6514 3.75008 17.008 3.93174C17.3216 4.09153 17.5765 4.34649 17.7363 4.6601C17.918 5.01662 17.918 5.48333 17.918 6.41675V7.50008C17.918 8.27665 17.918 8.66494 17.7911 8.97122C17.6219 9.3796 17.2975 9.70406 16.8891 9.87321C16.5828 10.0001 16.1945 10.0001 15.418 10.0001M10.8346 16.2501H4.7513C3.81788 16.2501 3.35117 16.2501 2.99465 16.0684C2.68105 15.9086 2.42608 15.6537 2.26629 15.3401C2.08464 14.9835 2.08464 14.5168 2.08464 13.5834V12.5001C2.08464 11.7235 2.08464 11.3352 2.2115 11.0289C2.38066 10.6206 2.70512 10.2961 3.1135 10.1269C3.41978 10.0001 3.80807 10.0001 4.58464 10.0001M8.58464 12.0834H11.418C11.6513 12.0834 11.768 12.0834 11.8571 12.038C11.9355 11.9981 11.9993 11.9343 12.0392 11.8559C12.0846 11.7668 12.0846 11.6501 12.0846 11.4167V8.58342C12.0846 8.35006 12.0846 8.23338 12.0392 8.14425C11.9993 8.06585 11.9355 8.00211 11.8571 7.96216C11.768 7.91675 11.6513 7.91675 11.418 7.91675H8.58464C8.35128 7.91675 8.2346 7.91675 8.14547 7.96216C8.06707 8.00211 8.00333 8.06585 7.96338 8.14425C7.91797 8.23338 7.91797 8.35006 7.91797 8.58342V11.4167C7.91797 11.6501 7.91797 11.7668 7.96338 11.8559C8.00333 11.9343 8.06707 11.9981 8.14547 12.038C8.2346 12.0834 8.35128 12.0834 8.58464 12.0834ZM14.8346 18.3334H17.668C17.9013 18.3334 18.018 18.3334 18.1071 18.288C18.1855 18.2481 18.2493 18.1843 18.2892 18.1059C18.3346 18.0168 18.3346 17.9001 18.3346 17.6667V14.8334C18.3346 14.6001 18.3346 14.4834 18.2892 14.3943C18.2493 14.3159 18.1855 14.2521 18.1071 14.2122C18.018 14.1667 17.9013 14.1667 17.668 14.1667H14.8346C14.6013 14.1667 14.4846 14.1667 14.3955 14.2122C14.3171 14.2521 14.2533 14.3159 14.2134 14.3943C14.168 14.4834 14.168 14.6001 14.168 14.8334V17.6667C14.168 17.9001 14.168 18.0168 14.2134 18.1059C14.2533 18.1843 14.3171 18.2481 14.3955 18.288C14.4846 18.3334 14.6013 18.3334 14.8346 18.3334ZM2.33464 5.83341H5.16797C5.40132 5.83341 5.518 5.83341 5.60713 5.788C5.68553 5.74805 5.74927 5.68431 5.78922 5.60591C5.83464 5.51678 5.83464 5.4001 5.83464 5.16675V2.33341C5.83464 2.10006 5.83464 1.98338 5.78922 1.89425C5.74927 1.81585 5.68553 1.75211 5.60713 1.71216C5.518 1.66675 5.40132 1.66675 5.16797 1.66675H2.33464C2.10128 1.66675 1.9846 1.66675 1.89547 1.71216C1.81707 1.75211 1.75333 1.81585 1.71338 1.89425C1.66797 1.98338 1.66797 2.10006 1.66797 2.33341V5.16675C1.66797 5.4001 1.66797 5.51678 1.71338 5.60591C1.75333 5.68431 1.81707 5.74805 1.89547 5.788C1.9846 5.83341 2.10128 5.83341 2.33464 5.83341Z"
      />
    </svg>
  ) : Props.libType === constants.libTypeIds.SQL ? (
    <svg
      width={Props.component === "DashBoard" ? "12" : "24"}
      height={Props.component === "DashBoard" ? "12" : "24"}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 11.75C20 16.417 4 16.417 4 11.75M12 3C7.582 3 4 4.29 4 5.88C4 10.04 20 10.04 20 5.88C20 4.29 16.418 3 12 3Z"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 6V18.165C4 21.945 20 21.945 20 18.165V6"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
      />
    </svg>
  ) : (
    <svg
      width={Props.component === "DashBoard" ? "12" : "20"}
      height={Props.component === "DashBoard" ? "12" : "20"}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={Props.className ?? ""}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={
          Props.component === "DashBoard"
            ? "#98A2B3"
            : Props.component === "learnerDashBoard"
            ? "#344054"
            : Props.disabled
            ? "#667085"
            : Props.active
            ? "#F96343"
            : "#EAECF0"
        }
        d="M4.16683 15.4167C4.16683 15.8037 4.16683 15.9972 4.18822 16.1597C4.33591 17.2815 5.21868 18.1643 6.34051 18.312C6.50297 18.3333 6.69648 18.3333 7.0835 18.3333H13.5002C14.9003 18.3333 15.6004 18.3333 16.1351 18.0609C16.6055 17.8212 16.988 17.4387 17.2277 16.9683C17.5002 16.4335 17.5002 15.7335 17.5002 14.3333V8.32353C17.5002 7.71205 17.5002 7.40631 17.4311 7.11859C17.3698 6.8635 17.2688 6.61964 17.1318 6.39596C16.9772 6.14367 16.761 5.92747 16.3286 5.4951L13.6717 2.83824C13.2394 2.40587 13.0232 2.18968 12.7709 2.03507C12.5472 1.898 12.3033 1.79699 12.0482 1.73575C11.7605 1.66667 11.4548 1.66667 10.8433 1.66667H7.0835C6.69648 1.66667 6.50297 1.66667 6.34051 1.68806C5.21868 1.83575 4.33591 2.71852 4.18822 3.84036C4.16683 4.00281 4.16683 4.19632 4.16683 4.58334M7.50016 12.0833L9.5835 10L7.50016 7.91667M4.16683 7.91667L2.0835 10L4.16683 12.0833"
      />
    </svg>
  );
}
